import React from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  ArticleDatatable = (props) => {

    const [t] = useTranslation();     
 
    const tableName = t('article.label.articles'); 
   
    const columns = [       
             { name: "Id", data: "id", selector: "id", omit: true},
             { name: t('general.label.name'), data: "name", sortable: true, selector: "name", minWidth: '500px'},    		
             { name: t('article.label.articleNumber'), data: "nbr", sortable: true, selector: "nbr"},    		
             { name: t('article.label.measureUnit'), data: "measureUnit",  sortable: true,  selector: "measureUnit"},
             { name: t('article.label.goodsOrService'), data: "goodsOrService", sortable: true,  selector: "goodsOrService"},                  
             { name: t('article.label.specification'), data: "specification.name", sortable: true,  selector: "specification.name"},
             { name: t('article.label.sellingPriceExcludeVat'), data: "sellingPriceExcludeVat", sortable: true,  selector: "sellingPriceExcludeVat"},
             { name: t('article.label.sellingPriceIncludeVat'), data: "sellingPriceIncludeVat", sortable: true,  selector: "sellingPriceIncludeVat"},
             { name: t('article.label.vat'), data: "vat", sortable: true,  selector: "vat"},
             { name: t('article.label.purchasePriceExcludeVat'), data: "purchasePriceExcludeVat", sortable: true,  selector: "purchasePriceExcludeVat"},
             { name: t('article.label.purchasePriceIncludeVat'), data: "purchasePriceIncludeVat", sortable: true,  selector: "purchasePriceIncludeVat"},
             { name: t('general.label.description'), data: "description", sortable: true,  selector: "description"}
     ];        
 
 
         
     const columnsData = [       
         { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
         { name: t('general.label.name'), data: "name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
         { name: t('article.label.articleNumber'), data: "nbr", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('article.label.measureUnit'), data: "measureUnit", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('article.label.goodsOrService'), data: "goodsOrService", orderable: true,  searchable: true, search: {value: '',regex: false}},                 
         { name: t('article.label.specification'), data: "specification.name", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('article.label.sellingPriceExcludeVat'), data: "sellingPriceExcludeVat", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('article.label.sellingPriceIncludeVat'), data: "sellingPriceIncludeVat", orderable: true,  searchable: true, search: {value: '',regex: false}},                
         { name: t('article.label.vat'), data: "vat", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('article.label.purchasePriceExcludeVat'), data: "purchasePriceExcludeVat", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('article.label.purchasePriceIncludeVat'), data: "purchasePriceIncludeVat", orderable: true,  searchable: true, search: {value: '',regex: false}},                
         { name: t('general.label.description'), data: "description", orderable: true,  searchable: true, search: {value: '',regex: false}}                 
     ];        
     const url = RestService.getBaseURL()+"article/getList";   
     const urlExcel = RestService.getBaseURL()+"";          
    
   
 
   

     const handleCallback  = (id) => {
             props.parentCallback(id);                   
     };
   
          
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={true}
             />
           
         );
    
 
  
 };

export default ArticleDatatable;

